import type BookingServiceWindow from 'owa-service/lib/contract/BookingServiceWindow';
import type {
    BookingServiceWindow as B2BookingServiceWindow,
    BookingWorkHours,
} from 'owa-graph-schema';
import mapBookingWorkHours from './mapBookingWorkHours';

const DEFAULT_SERVICE_WINDOWS: BookingServiceWindow[] = [
    {
        StartString: undefined,
        EndString: undefined,
        BookableHours: [],
    },
];

const mapB2BookingServiceWindow = (
    bookingServiceWindows: B2BookingServiceWindow[]
): BookingServiceWindow[] => {
    const modifiedBookingServiceWindows: BookingServiceWindow[] = !!bookingServiceWindows?.[0]
        ?.bookableHours
        ? bookingServiceWindows.map(bookingServiceWindow => ({
              StartString: bookingServiceWindow.startDate ?? '',
              EndString: bookingServiceWindow.endDate ?? '',
              BookableHours: mapBookingWorkHours(
                  bookingServiceWindow.bookableHours as BookingWorkHours[]
              ),
          }))
        : DEFAULT_SERVICE_WINDOWS;
    return modifiedBookingServiceWindows;
};

export default mapB2BookingServiceWindow;
